<template>
  <div class="view d-flex justify-content-center align-items-center px-4">
    <div>
      <div class="row mb-4">
        <div class="col text-center"><img v-bind:src="logo" alt="MusicBox Logo" class="img-fluid"></div>
      </div>
      <div class="form-group">
        <input v-model="email" type="text" class="form-control rounded border-primary" :placeholder="$t('Email')">
      </div>
      <div class="form-group">
        <input v-model="password" type="password" class="form-control rounded border-primary" :placeholder="$t('Password')" @keyup.enter="onEnter">
      </div>
      <div class="form-group text-center">
        <a :disabled="disableLogin" @click="login()" class="btn btn-primary rounded px-4">
          <span
            :style="{ display: disableLogin ? 'block' : 'none' }"
          >&nbsp;&nbsp;&nbsp;&nbsp;<FontAwesomeIcon icon="spinner" spin />&nbsp;&nbsp;&nbsp;&nbsp;</span>
          <span :style="{ display: !disableLogin ? 'block' : 'none' }">{{$t('Sign In')}}</span>
        </a>
      </div>
      <div class="text-center mt-5" v-if="subscribeLink">
        <a :href="subscribeLink" class="text-primary">{{$t('Your account has expired. Click here to subscribe.')}}</a>
      </div>
      <div class="text-center mt-5" v-else>
        <a href="https://musicbox.hr/#contact" class="text-primary">{{$t('Forgot Password')}}</a>
      </div>
    </div>
    <div class="footer text-white bg-dark pb-1 pt-0 text-center">
      <small><a href="https://musicbox.hr/#contact" class="white_link">{{$t('Need Help')}}</a></small>
    </div>
  </div>
</template>

<script>
import logo from '@/images/logo-white.png'
import { ROUTE_DASHBOARD } from '@/const/routeNames'
import localStorageUtil from '@/utils/localStorageUtil'
import musicboxClient from '@/utils/musicboxClient'
import i18n from '@/translations'
import messages from '@/translations/messages'

export default {
  name: 'Login',
  data: () => {
    return {
      logo,
      email: '',
      password: '',
      disableLogin: false
    }
  },
  computed: {
    subscribeLink () {
      const link = this.$store.state.auth.subscribeLink
      if (!link) return null

      return `https://musicbox.hr${link}`
    }
  },
  methods: {
    login () {
      if (this.disableLogin) { return }
      this.disableLogin = true
      musicboxClient
        .loginRequest({ email: this.email, password: this.password })
        .then(res => {
          if (res && res.status === 200) {
            localStorageUtil.setToken(res.data.token)
            localStorageUtil.setUserEmail(res.data.email)
            localStorageUtil.setUserProvider(res.data.provider)
            localStorageUtil.setUserIsStaff(res.data.is_staff)
            this.$store.commit('setAuthorized', true)
            this.$store.commit('setUserEmail', res.data.email)
            this.$store.commit('setUserProvider', res.data.provider)
            this.$store.commit('setUserIsStaff', !!res.data.is_staff)
            if (window.innerWidth >= 992) {
              this.$store.commit('setSidebarOpen', true)
            }

            this.$router.push(ROUTE_DASHBOARD)
            if (res.data.translate && typeof res.data.translate === 'object') {
              localStorageUtil.setTranslations(res.data.translate)
              i18n.setLocaleMessage('en', Object.assign(messages.en, res.data.translate))
            }
            if (res.data.trial_days_left !== null && res.data.trial_days_left <= 15) {
              this.$notify.danger(this.$t('You have {daysLeft} days left', { daysLeft: res.data.trial_days_left }))
            }
            musicboxClient
              .getBoxes()
              .then(boxRes => {
                const currentBox = (boxRes.data && boxRes.data[0] ? boxRes.data[0] : null)
                localStorageUtil.setCurrentBox(currentBox)
                this.$store.commit('setCurrentBox', currentBox)
                localStorageUtil.setAllBoxes(boxRes.data)
                this.$store.commit('setAllBoxes', boxRes.data)
              })
              .catch(e => {
                this.$notify.danger(this.$t('Failed to get user boxes'))
              })
          }
        })
        .catch(err => {
          if (err.response) {
            this.$notify.danger(this.$t('Invalid username or password'))
          }
        })
        .then(() => { this.disableLogin = false })
    },
    onEnter () {
      if (this.email && this.password && !this.disableLogin) {
        this.login()
      }
    }
  }
}
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/Login.vue